import { Sankey } from '@ant-design/plots';
import React, { FC, useEffect, useState } from 'react';
export interface SankeyData {
  source: string;
  target: string;
  value: number;
  color: string;
}
type SankeyChartProps = { data: SankeyData[]; onClick?: (e: any) => void };

const SankeyChart: FC<SankeyChartProps> = sankeyData => {
  const { data, onClick } = sankeyData;
  const [loading, setloading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setloading(false);
    }, 1000);
  }, []);

  const config = {
    data: data as any,
    sourceField: 'source',
    targetField: 'target',
    weightField: 'value',
    color: Array.from(new Set(data.map(i => i.color))),
    nodeWidthRatio: 0.008,
    nodePaddingRatio: 0.03,
    onReady: (graph: any) => {
      console.log('graph', graph);

      graph.on('element:click', (...args: any) => {
        onClick && onClick(args);
      });
    },
  };

  return (
    <>
      <Sankey style={{ width: '97%' }} loading={loading} {...config} />
    </>
  );
};

export default SankeyChart;
